import methods from '@/services/methods'

export default {
  validateEmail (payload) {
    return methods.sendPost('signup/validate', payload, {restrictToast: true})
  },
  verifyLink (payload) {
    return methods.sendPost('signup/verify_link', payload, {restrictToast: true})
  },
  onboard (payload) {
    return methods.sendPost('signup/onboard', payload)
  }
}
